'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactCssModules = require('react-css-modules');

var _reactCssModules2 = _interopRequireDefault(_reactCssModules);

var _components = require('../../components');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Styles = require('./TargetDateSeriesFullScorecard.css');

var TargetDateSeriesFullScorecard = (_dec = (0, _reactCssModules2.default)(Styles, { allowMultiple: true }), _dec(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(TargetDateSeriesFullScorecard, _Component);

  function TargetDateSeriesFullScorecard(props) {
    (0, _classCallCheck3.default)(this, TargetDateSeriesFullScorecard);
    return (0, _possibleConstructorReturn3.default)(this, (TargetDateSeriesFullScorecard.__proto__ || (0, _getPrototypeOf2.default)(TargetDateSeriesFullScorecard)).call(this, props));
  }

  (0, _createClass3.default)(TargetDateSeriesFullScorecard, [{
    key: 'render',
    value: function render() {
      var targetDateSeries = this.props.targetDateSeries;


      return _react2.default.createElement(
        'div',
        { styleName: 'full-scorecard card' },
        _react2.default.createElement(
          'div',
          { styleName: 'scorecard-header' },
          _react2.default.createElement(
            'b',
            null,
            'Environmental'
          ),
          ' scorecard'
        ),
        ['fff', 'dff'].map(function (e, i) {
          return _react2.default.createElement(_components.TargetDateSeriesScorecardRow, {
            key: 'scrd-lnk-e-' + i,
            iyvCode: e,
            targetDateSeries: targetDateSeries
          });
        }),
        _react2.default.createElement(
          'div',
          { styleName: 'scorecard-header' },
          _react2.default.createElement(
            'b',
            null,
            'Social'
          ),
          ' scorecard'
        ),
        ['gef', 'gff', 'pff', 'wff', 'tff'].map(function (e, i) {
          return _react2.default.createElement(_components.TargetDateSeriesScorecardRow, {
            key: 'scrd-lnk-s-' + i,
            iyvCode: e,
            targetDateSeries: targetDateSeries
          });
        }),
        _react2.default.createElement(_components.TargetDateSeriesFundDetails, {
          targetDateSeries: targetDateSeries
        })
      );
    }
  }]);
  return TargetDateSeriesFullScorecard;
}(_react.Component), _class2.propTypes = {
  // the target date series object
  targetDateSeries: _react.PropTypes.object.isRequired
}, _temp)) || _class);
exports.default = TargetDateSeriesFullScorecard;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/TargetDateSeriesFullScorecard/TargetDateSeriesFullScorecard.js
// module id = 1447
// module chunks = 0